import { styled, Theme, CSSObject } from '@mui/material/styles'
import MuiDrawer from '@mui/material/Drawer'

export const StyledDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  ...theme.mixins.toolbar,
  justifyContent: 'space-between',
}))

export const drawerWidth = 250
export const drawerBgColor = 'rgb(18, 22, 33)'
export const drawerTxtColor = 'rgb(179, 185, 198)'
export const drawerActiveTxtColor = 'white'

export const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  color: drawerTxtColor,
  backgroundColor: drawerBgColor,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
})

export const closedMixin = (theme: Theme): CSSObject => ({
  width: `calc(${theme.spacing(7)} + 9px)`,
  color: drawerTxtColor,
  backgroundColor: drawerBgColor,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.shortest,
  }),
  overflowX: 'hidden',
  // [theme.breakpoints.up('sm')]: {
  //   width: `calc(${theme.spacing(8)} + 170px)`,
  // },
})

export const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: prop => prop !== 'open',
})<{ open?: boolean }>(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open
    ? {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
      }
    : {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
      }),
}))
